/* eslint-disable eqeqeq */
/*
 * Created Date: 03-09-2023, 11:04:01 pm
 * Author: Peter
 * Email: phantrung696@gmail.com
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2023 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import BaseService from '@Core/axios/BaseService'
import { isLocalhost } from '@Core/Helpers/Url'
import { QUIZ_BE_API_URL, STUDIO_BE_URL } from 'env'

// https://wfxowxvppdovehvbwbwp.supabase.co
// import { createClient } from '@supabase/supabase-js'

// // Create a single supabase client for interacting with your database
// const supabase = createClient(
// 	'https://wfxowxvppdovehvbwbwp.supabase.co',
// 	'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndmeG93eHZwcGRvdmVodmJ3YndwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjUyOTA0MjgsImV4cCI6MjA0MDg2NjQyOH0.ZHp2ay0TgrKbvTwQQaryQcFt0QJ5taB75t7RlZKavuo'
// )

class QuizExam extends BaseService {
	CHANNEL_ALIAS = ''

	BASE_URL = 'https://studio-api-07.eduquiz.io.vn'

	constructor(params) {
		super(params)
		this.setRequest()
	}

	setChannelQuiz = alias => {
		this.CHANNEL_ALIAS = alias
	}

	getExamMeta = alias => {
		const endpoint = `/quiz-chanel/public/api/v1/exams/${alias}/meta`
		return this.withCache(() => this.request.get(endpoint), endpoint)
	}

	getExamExtendData = id => {
		const endpoint = `/quiz-chanel/public/api/v1/exams/${id}/extend-data`
		return this.withCache(() => this.request.get(endpoint), endpoint, 0)
	}

	getPreviewExam = (id, params) => {
		// return supabase.from('quiz_exam_sections').select(`*,quiz_questions(*) AS questions `).eq('exam_id', id)
		// if (params?.pgsql) {
		// 	return supabase.from('quiz_exam_section')
		// }
		const endpoint = `/quiz-chanel/public/api/v1/exams/${id}/preview?exam_id=${id}`
		return this.withCache(
			() =>
				this.request.get(endpoint, {
					...params,
					headers: {
						'chanel-quiz': this.CHANNEL_ALIAS
					}
				}),
			endpoint
		)
	}

	getExamSections = (id, params = {}) => {
		const endpoint = `/quiz-chanel/public/api/v1/exams/${id}/sections`

		return this.withCache(
			() =>
				this.request.get(endpoint, {
					params,
					headers: {
						'chanel-quiz': this.CHANNEL_ALIAS
					}
				}),
			endpoint
		)

		// return this.withCache(() => this.request.get(endpoint, { params }), endpoint, 0)
	}

	favoriteExam = (id, params) => {
		// unfavorite
		const endpoint = `/quiz/api/v1/user/exams/${id}/favorite`
		// const headers = this.getExamChannelHeader()
		return this.request.post(endpoint, null, { params })
	}

	unfavoriteExam = (id, params) => {
		const endpoint = `/quiz/api/v1/user/exams/${id}/unfavorite`
		// const headers = this.getExamChannelHeader()
		return this.request.post(endpoint, null, { params })
	}

	likeExam = (id, params) => {
		// unfavorite
		const endpoint = `/quiz/api/v1/user/exams/${id}/like`
		// const headers = this.getExamChannelHeader()
		return this.request.post(endpoint, null, { params })
	}

	unlikeExam = (id, params) => {
		const endpoint = `/quiz/api/v1/user/exams/${id}/unlike`
		// const headers = this.getExamChannelHeader()
		return this.request.post(endpoint, null, { params })
	}

	checkAllowAccessExam = id => {
		const endpoint = `/quiz/api/v1/public/exams/${id}/check-allow-access`
		return this.request.get(endpoint)
	}

	checkPassword = (id, data) => {
		const endpoint = `/quiz/api/v1/public/exams/${id}/check-password`
		return this.request.post(endpoint, data)
	}

	createExamResult = data => {
		const endpoint = `/quizexam/studio/api/v1/user/exam-results`
		return this.request.post(endpoint, data)
	}

	submitExamResult = data => {
		const endpoint = `/quizexam/studio/api/v1/user/exam-results/submit?telescope=1`
		return this.request.put(endpoint, data)
	}

	cancelExamResult = id => {
		const endpoint = `quizexam/studio/api/v1/user/exam-results/${id}/cancel`
		return this.request.put(endpoint)
	}

	getSettingScreenSaver = () => {
		const endpoint = '/quiz/api/v1/public/setting-screen-saver'
		return this.withCache(() => this.request.get(endpoint), 'setting-screen-saver')
	}

	viewExam = exam_id => {
		const endpoint = '/quiz/api/v1/public/exam-count?telescope=1'
		//
		return this.request.post(endpoint, { exam_id })
	}

	// flash card
	getFlashcardExam = exam_id => {
		const endpoint = `quizexam/studio/api/v1/user/exam/${exam_id}/flashcard-study`

		return this.request.get(endpoint)
	}

	saveFlashcardExam = data => {
		const endpoint = 'quizexam/studio/api/v1/user/flashcard-study'

		return this.request.post(endpoint, data)
	}

	updateFlashcard = (id, data) => {
		const endpoint = `quizexam/studio/api/v1/user/flashcard-study/${id}`

		return this.request.put(endpoint, data)
	}

	// highlight note
	createHighlightNote = data => {
		const endpoint = 'quizexam/studio/api/v1/user/exam-highlights'

		return this.request.post(endpoint, data)
	}

	getHighlightBy = params => {
		const endpoint = 'quizexam/studio/api/v1/user/exam-highlights'

		return this.request.get(endpoint, { params })
	}

	getDetailHighlight = id => {
		const endpoint = `quizexam/studio/api/v1/user/exam-highlights/${id}`

		return this.request.get(endpoint)
	}

	updateHighlightNote = (id, data) => {
		const endpoint = `quizexam/studio/api/v1/user/exam-highlights/${id}`

		return this.request.put(endpoint, data)
	}

	deleteHighlightNote = id => {
		const endpoint = `quizexam/studio/api/v1/user/exam-highlights/${id}`

		return this.request.delete(endpoint)
	}

	downloadExam = params => {
		const endpoint = '/quiz/api/v1/user/update-download-exam'
		return this.request.post(endpoint, null, { params })
	}

	saveLog = data => {
		const endpoint = '/examroom/api/v1/candidate/activity-log'
		return this.request.post(endpoint, data)
	}

	getRanking = params => {
		const endpoint = '/workspace/public/api/v1/exams/rankings'
		return this.request.get(endpoint, { params })
	}

	saveFlashcardLog = exam_id => {
		const endpoint = `${QUIZ_BE_API_URL}/api/user/v1/flashcards/activity-log`
		return this.request.post(endpoint, { exam_id })
	}
}

const quizExamService = new QuizExam()

export default quizExamService
